import React from "react";
import { FileLayoutMaintenancePageInitialState, PageNewState } from ".";

export const FileLayoutMaintenancePageContext = React.createContext({
  pageState: FileLayoutMaintenancePageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
